export const MIN_CHARS_TO_DISPLAY_SUGGEST = 2;
